import { parseAuthoringJSON } from "./authoring-json.mjs";

export function routeFileResult(value) {
  if (!value || !["preview","queued"].includes(value.state) || typeof value.document !== "string") return null;
  try {
    const document = parseAuthoringJSON(value.document);
    if (document?.kind !== "agent_pipeline_route_edit" || String(document.version) !== "2" || document.routes?.length !== 1) return null;
    const id = String(document.routeId);
    if (!/^[1-9]\d{0,18}$/.test(id) || String(document.routes[0].id) !== id) return null;
    return { content: value.document, filename: `route-${id}.json`, routeId: id, title: typeof document.routes[0].name === "string" ? document.routes[0].name : `Маршрут #${id}`, preview: value.state === "preview" };
  } catch { return null; }
}
